import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=5238da9a&scoped=true"
var script = {}
import style0 from "./Copyright.vue?vue&type=style&index=0&id=5238da9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5238da9a",
  null
  
)

export default component.exports